import { render } from "./ModalTransferBtcAccept.vue?vue&type=template&id=f1db430c&scoped=true&ts=true"
import script from "./ModalTransferBtcAccept.vue?vue&type=script&lang=ts"
export * from "./ModalTransferBtcAccept.vue?vue&type=script&lang=ts"

import "./ModalTransferBtcAccept.vue?vue&type=style&index=0&id=f1db430c&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1db430c"]])

export default __exports__